<!--
 * @author: JJ
 * @since: 2024-09-30
 * Cart.vue
-->
<template>
    <div class="container pbrem2">
        <Header />
        <div class="top_nav ptb10">
            <div class="w1400 flex-box">
                <img src="../../assets/static/images/jj_logo_new.png" class="logo cursor" alt="" @click="$router.push('/')">
                <div class="flex-grow-1 pl60">
                    <div class="pl60 top_title fs18">采购车</div>
                </div>
            </div>
        </div>
        <div class="w1400 mt25 fs14 cursor"><span class="col90">当前位置：</span><router-link to="/" class="col04">首页
                /</router-link><span class="now_page"> 采购车</span></div>
        <div class="flex flex-self-end w1400 mt30">
            <div class="cart_tab fs18" :class="query.type == item.id ? 'ac' : ''" v-for="(item, index) in tablist"
                :key="index" @click="tabChange(item.id)">{{ item.name }}
            </div>
            <div class="flex-grow-1 tr cu">
                <span class="col127 fs16 fw600">{{ query.type == "general" ? "产品商城" : "活动中心" }}({{ list.length }}) /
                </span>
                <span class="col90 fs16">全部商品({{ total_num }})</span>
            </div>
        </div>
        <div class="w1400 mt15">
            <div class="cart_tab_nav flex-box fs16 col04">
                <img @click="onSelectAll()" v-if="isAllSelected" src="../../assets/static/icon/jj_choose_sc.png"
                    class="choose_ico cursor" alt="">
                <img @click="onSelectAll()" v-else src="../../assets/static/icon/jj_choose_uc.png"
                    class="choose_ico cursor" alt="">
                <div @click="onSelectAll()" class="ml32 w144">全选</div>
                <div class="w318 tc ">商品</div>
                <div class="w68 tc">规格</div>
                <div class="w160 tc">单价(元)</div>
                <div class="w166 tc pr66">优惠</div>
                <div class="w152 tc">数量</div>
                <div class="w166 tc">小计(元)</div>
                <div class="w50">操作</div>
            </div>
            <div v-if="list.length <= 0 && loseList.length <= 0" class="nothing_box flex-box flex-col flex-center">
                <img src="../../assets/static/images/jj_null.png" class="null" alt="">
                <router-link to="/">
                    <img src="../../assets/static/images/jj_return.png" class="return" alt="">
                </router-link>
            </div>
            <template v-if="list.length > 0">
                <div class="goods_item pl45 flex-box" v-for="(item, index) in list" :key="index">
                    <img v-if="selectedIds.includes(item.id)" @click.stop="onSelectSingle(item.id)"
                        src="../../assets/static/icon/jj_choose_sc.png" class="choose_ico" alt="">
                    <img v-else @click.stop="onSelectSingle(item.id)" src="../../assets/static/icon/jj_choose_uc.png"
                        class="choose_ico" alt="">
                    <div class="ml32 w144 " @click="onDetail(item)">
                        <img :src="item.goods.image_text" class="goods_cover" alt="">
                    </div>
                    <div class="w318 col04 fs14 lh22 m-ellipsis-l2" @click="onDetail(item)"> <span
                            v-if="item.activity && item.activity.type !== 'none'" class="tips lq_tips">{{
                                item.activity.title }}</span>
                        <!-- <span v-else-if="item.activity && item.activity" class="tips ">{{ item.activity.title }}</span> -->
                        {{ item.goods.title }}</div>
                    <div class="w68 col04 fs14 tc">{{ item.sku_price.goods_sku_text }}</div>
                    <div class="w160 tc col90 fs14">{{ item.goods_price }}</div>

                    <div v-if="item.tags && item.tags.price" class="w166 flex-box">
                        <img src="../../assets/static/icon/jj_arrow_down.png" class="arrow_down" alt="">
                        <div class="pl5 coleb fs14" :class="item.tags && item.tags.price ? 'coleb' : 'cold8'">
                            {{ item.tags.price }}元</div>
                    </div>
                    <div v-else class="w166 flex-box">
                        <div class="pl5 coleb fs14 cold8">
                            暂无优惠</div>
                    </div>

                    <!-- <template v-else>
                        <div class="w166 flex-box">
                            <div class="pr">
                                <div class="select_box" @click="select">
                                    <div class="flex-grow-1">促销优惠</div>
                                    <img src="../../assets/static/icon/jj_select_down.png" v-if="hidden" class="arrow"
                                        alt="">
                                    <img src="../../assets/static/icon/jj_select_up.png" v-else class="arrow" alt="">
                                </div>
                                <div class="select_link" v-if="!hidden">
                                    <div class="select_link_item">临期产品已减30元</div>
                                    <div class="select_link_item">临期产品已减30元</div>
                                    <div class="select_link_item">临期产品已减30元</div>
                                </div>
                            </div>
                        </div>
                    </template> -->
                    <div class="w152 flex-box">
                        <img @click.stop="onNumberChange('minus', item)" src="../../assets/static/icon/jj_del.png"
                            class="del_item cu" alt="">
                        <div class="inp_nav">
                            <input maxlength="4" @input.stop="onInput($event, item)"
                                @blur.stop="onBlur($event, item, index)" v-model="item.goods_num">
                        </div>
                        <img @click.stop="onNumberChange('plus', item)" src="../../assets/static/icon/jj_add.png"
                            class="del_item cu" alt="">
                    </div>
                    <div class="w166 tc coleb fs18 fwb">{{ (Number(item.goods_price) * item.goods_num).toFixed(2) }}
                    </div>
                    <div class="flex flex-col col90 fs14 tl w50">
                        <div class="cu tdl" @click.stop="deleteCart(item.id)">删除</div>
                        <div class="mt20 cu tdl" @click.stop="oneCollect(item.id)">移入收藏</div>
                    </div>
                </div>
            </template>
        </div>
        <div v-if="loseList.length > 0" class="w1400 mt10">
            <div class="cart_tab_nav flex-box pr45">
                <div class="flex-grow-1 fs18 col04">{{ loseList.length }}件失效商品</div>
                <div class="col127 fs14 cu" @click="onClearLossCart()">清除失效商品</div>
            </div>
            <div class="goods_item fs14 pl20 flex-box" v-for="(item, index) in loseList" :key="index">
                <div class="tips_no">失效</div>
                <div class="ml20 w144 ">
                    <img :src="item.goods.image_text" class="goods_cover" alt="">
                </div>
                <div class="w318 col04 lh22 m-ellipsis-l2"><span class="tips lq_tips"
                        v-if="item.activity && item.activity.type !== 'none'">{{ item.activity.title }}</span>
                    <!-- <span class="tips" v-else>{{item.activity.title }}</span> -->
                    {{ item.goods.title }}</div>
                <div class="w68 col04 ">{{ item.sku_price.goods_sku_text }}</div>
                <div class="w160 tc col90 ">{{ item.goods_price }}</div>
                <div class="w166 flex-box" v-if="item.tags && item.tags.price">
                    <img src="../../assets/static/icon/jj_arrow_down_uc.png" class="arrow_down" alt="">
                    <div class="pl5 coleb " :class="item.tags && item.tags.price ? 'coleb' : 'cold8'"> {{
                        item.tags.price }}</div>
                </div>
                <div class="w166 flex-box" v-else>
                    <img src="../../assets/static/icon/jj_arrow_down_uc.png" class="arrow_down" alt="">
                    <div class="pl5 coleb cold8">暂无优惠</div>
                </div>
                <!-- <div class="w166 flex-box" v-else>
                    <div class="pr">
                        <div class="select_box disabled">
                            <div class="flex-grow-1">促销优惠</div>
                            <img src="../../assets/static/icon/jj_select_down_uc.png" v-if="hidden" class="arrow"
                                alt="">
                            <img src="../../assets/static/icon/jj_select_up.png" v-else class="arrow" alt="">
                        </div>

                    </div>
                </div> -->
                <div class="w152 flex-box pl20">
                    <img src="../../assets/static/icon/jj_icon_warning.png" class="ico20" alt="">
                    <div class="coleb fs14 col18 pl5">已被抢光</div>
                </div>
                <div class="w166 tc coleb fs14 fwb"></div>
                <div class="flex flex-col col90 fs14 tl w50">
                    <div class="cu tdl" @click="deleteCart(item.id)">删除</div>
                    <div class="mt20 cu tdl" @click="oneCollect(item.id)">移入收藏</div>
                </div>
            </div>
        </div>
        <div class="w1400 h88 flex-box pl45 pr25 mt10">
            <img @click="onSelectAll()" v-if="isAllSelected" src="../../assets/static/icon/jj_choose_sc.png"
                class="choose_ico cursor" alt="">
            <img @click="onSelectAll()" v-else src="../../assets/static/icon/jj_choose_uc.png" class="choose_ico cursor"
                alt="">
            <div @click="onSelectAll()" class="pl35 col90 fs14 cursor">全选</div>
            <div class="pl45 fs14 col90 cursor" @click="onMultiDeleteCart()">删除选中的商品</div>
            <div class="fs14 col90 pl45 cursor" @click="multiCollect()">移入收藏</div>
            <div class="flex-grow-1">
                <!-- <div class="tr fs16 col04">共减 <span class="coleb fs16 fw600">¥ </span></div> -->
                <div class="flex-box">
                    <div class=" flex-grow-1 tr fs16 col04">已选中 <span class="col127">{{ totalNum }}</span> 件商品，总价：</div>
                    <div class="coleb fs16 fw600">¥ {{ totalPrice }}</div>
                </div>
            </div>
            <div @click="onConfirm" class="cursor fs14" :class="totalNum > 0 ? 'btn_pay' : 'btn_pay disabled'">去结算</div>


        </div>
        <div class="recomd_box w1400 pb20 mt20" v-if="isLogin">
            <div class="recomd_tab flex-box ">
                <div class="recomd_tab_item " :class="myType == 'favourite' ? 'ac' : ''"
                    @click="changeMyType('favourite')">猜你喜欢
                </div>
                <div class="recomd_tab_item" :class="myType == 'scan' ? 'ac' : ''" @click="changeMyType('scan')">最近浏览
                </div>
                <div class="flex-box flex-grow-1 flex-end pr50 cursor" @click="fetchGuessGoods">
                    <img src="../../assets/static/icon/jj_refresh.png" class="ico20" alt="">
                    <div class="col127 fs16 ml20">换一批</div>
                </div>
            </div>
            <div class="mt20 plr45 ">
                <div class="recomd_item cursor" v-for="(item, index) in guessGoods" :key="index"
                    @click="goodsDetail(item.id)">
                    <img :src="item.image_text" class="cover" alt="">
                    <div class="flex-box">
                        <div class="flex-grow-1">
                            <div class="coleb fs14 fwb"><span class="fs16 coleb"
                                    v-if="item.min_max_price[0].min_price">¥
                                    {{ item.min_max_price[0].min_price + '~' + item.min_max_price[0].max_price
                                    }}</span></div>
                            <div class="fs16 col27 mt5">{{ item.title }}</div>
                        </div>

                        <img src="../../assets/static/icon/jj_icon_cart.png" class="ico56 cursor" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from "vue"
import { useHead } from '@unhead/vue'
onMounted(() => {
    useHead({
        title: "采购车-小狮优选",
        meta: [
            { name: "description", content: "This is my page description" },
            { property: "og:title", content: "My Page Title" },
            { property: "og:description", content: "This is my page description" },
            { property: "og:url", content: "https://example.com/my-page" },
            { property: "og:image", content: "https://example.com/my-image.jpg" },
        ],
        link: [{ rel: "canonical", href: "https://example.com/my-page" }],
    })
})
let nindex = ref(0)
let tab = ref(['产品商城', '活动中心'])
let inp_val = ref('1')
let hidden = ref(true)
const chooseNav = (i) => {
    nindex.value = i
}
const select = (i) => {
    hidden.value = !hidden.value
}
</script>
<script>
export default {
    data() {
        return {
            tablist: [{
                id: 'general',
                name: '产品商城'
            }, {
                id: 'activity',
                name: '活动中心'
            }],
            query: {
                type: 'general'
            },//顶部tab
            list: [],//商品
            total_num: 0,
            loseList: [],//失效商品
            selectedIds: [], // 已选列表
            isAllSelected: false, //是否全选
            cartSelectedTotalPrice: '0.00', // 选中项总金额           

            isLogin: false,
            myType: "favourite",
            guessGoods: [],

            upTimer: null
        }
    },
    created() {

    },
    mounted() {
        if (this.$cookies.get("token")) {
            this.isLogin = true;
        } else {
            this.isLogin = false;
        }
        this.fetch();
        this.fetchGuessGoods();
    },
    computed: {
        totalNum() {
            let total = 0;
            this.list.forEach((item) => {
                total += this.selectedIds.includes(item.id) ? 1 : 0;
            });
            return total;
        },
        totalPrice() {
            let price = 0;
            if (!this.selectedIds.length) {
                return price.toFixed(2);
            }
            this.list.forEach((item) => {
                price += this.selectedIds.includes(item.id) ? Number(item.goods_price) * item.goods_num : 0;
            });
            return price.toFixed(2);
        }
    },
    methods: {
        //获取列表
        fetch() {
            let that = this;
            that.$api.GetCarts(
                that.query
            ).then(res => {
                that.list = res.data.carts;
                that.loseList = res.data.lose_cart;
                that.total_num = res.data.total_num;
            })
        },
        onDetail(cart) {
            let query = { id: cart.goods_id };
            if (cart.activity_id) {
                query['activity_id'] = cart.activity_id;
            }
            this.$router.push({ path: '/FindProductDetail', query: query })
        },
        //切换/活动TAB
        tabChange(type) {
            this.list = [];
            this.selectedIds = [];
            this.isAllSelected = false;
            this.query.type = type;
            this.fetch();
        },
        //切换猜你喜欢
        changeMyType(myType) {
            this.myType = myType;
            this.fetchGuessGoods();
        },
        //获取列表
        fetchGuessGoods() {
            let that = this;
            that.$api.GuessLikeGoods(
                { type: this.myType }
            ).then(res => {
                that.guessGoods = res.data;
            })
        },
        goodsDetail(goodsId) {

            let routeUrl = this.$router.resolve({ path: '/FindProductDetail', query: { id: goodsId } })
            window.open(routeUrl.href, '_blank')
        },
        //单选
        onSelectSingle(goodsId) {
            if (!this.selectedIds.includes(goodsId)) {
                this.selectedIds.push(goodsId);
            } else {
                this.selectedIds.splice(this.selectedIds.indexOf(goodsId), 1);
            }
            this.isAllSelected = this.selectedIds.length === this.list.length;
        },
        //多选
        onSelectAll() {
            this.isAllSelected = !this.isAllSelected;
            if (!this.isAllSelected) {
                this.selectedIds = [];
            } else {
                this.list.forEach((item) => {
                    this.selectedIds.push(item.id);
                });
            }
        },
        //批量删除商品
        onMultiDeleteCart() {
            let selectedIds = this.selectedIds;
            if (selectedIds.length <= 0) {
                this.$message({ customClass: 'custom-message', message: "请选择商品", type: "error", duration: 1500, });
                return;
            }
            let ids = selectedIds.join(',');
            this.deleteCart(ids);
        },
        //清空失效商品
        onClearLossCart() {
            let selectedIds = [];
            this.loseList.forEach(item => {
                selectedIds.push(item.id);
            })
            if (selectedIds.length <= 0) {
                this.$message({ customClass: 'custom-message', message: "没有失效商品", type: "error", duration: 1500, });
                return;
            }
            let ids = selectedIds.join(',');
            this.deleteCart(ids);
        },
        //删除请求
        deleteCart(ids) {
            let that = this;
            this.$confirm('确认删除商品？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                that.$api.CartsDelete(
                    { id: ids.toString() }
                ).then(res => {
                    that.fetch();
                    that.cartNum();
                })
            });
        },
        //收藏
        oneCollect(id) {
            var ids = id;
            this.toggleCollect([ids]);
        },
        //批量收藏
        multiCollect() {
            var selectedIds = this.selectedIds;
            if (selectedIds.length <= 0) {
                this.$message({ customClass: 'custom-message', message: "请选择商品", type: "error", duration: 1500, });
                return;
            }
            this.toggleCollect(selectedIds);
        },
        //（取消）收藏
        toggleCollect(cartIds) {
            let that = this;
            let goodsIds = [];
            that.list.forEach(cart => {
                if (cartIds.includes(cart.id)) {
                    goodsIds.push(cart.goods_id);
                }
            })
            that.$api.Favorite({ goods_ids: goodsIds.join(',') }).then(res => {
                this.$message({ customClass: 'custom-message', message: "收藏成功", type: "success", duration: 1500, });
            })
        },
        onInput(event, cartItem) {
            //console.log(event)
            let goodsNum = event.target.value;
            if (!goodsNum || goodsNum < cartItem.buy_qi) {
                this.$message.error("最少购买" + cartItem.buy_qi + "件")
                cartItem.goods_num = cartItem.buy_qi;
                return;
            }
            cartItem.goods_num = goodsNum;
            this.updateNumber(cartItem)
        },
        onBlur(event, cartItem, index) {
            let goodsNum = event.detail.value;
            if (!goodsNum || goodsNum <= 0) {
                this.list[index].goods_num = cartItem.goods_num;
                this.$forceUpdate();
                return;
            }
        },
        onNumberChange(type, cartItem) {
            if (type == 'minus' && cartItem.goods_num == 1) {
                //cart.delete(cartItem.id);
                return;
            }
            if (type == 'minus') {
                cartItem.goods_num -= 1;
                if (!cartItem.goods_num || cartItem.goods_num < cartItem.buy_qi) {
                    this.$message.error("最少购买" + cartItem.buy_qi + "件")
                    cartItem.goods_num = cartItem.buy_qi;
                    return;
                }
            } else {
                cartItem.goods_num += 1;
            }
            this.updateNumber(cartItem)
        },
        updateNumber(cartItem) {
            let that = this;
            clearTimeout(that.upTimer);
            that.upTimer = setTimeout(function () {
                that.$api.CartsNumber(
                    {
                        type: 'cover',
                        goods_id: cartItem.goods_id,
                        goods_num: cartItem.goods_num,
                        goods_sku_price_id: cartItem.goods_sku_price_id,
                        showToast: true
                    }
                ).then(res => {
                    that.fetch();
                }).catch(err => {
                    console.log(err);
                    that.$message.error(err.msg);
                    cartItem.goods_num = err.data.goods_num;
                })
            }, 500);

        },
        //结算
        onConfirm() {
            let goods_list = [];
            this.selectedList = this.list.filter((item) => this.selectedIds.includes(item.id));
            this.selectedList.map((item) => {
                goods_list.push({
                    activity_id: item.activity_id,
                    activity_type: item.activity.type == 'none' ? '' : item.activity.type,
                    goods_id: item.goods_id,
                    goods_num: item.goods_num,
                    goods_sku_price_id: item.goods_sku_price_id,
                });
            });
            if (goods_list.length === 0) {
                return;
            }
            let data = JSON.stringify({
                order_type: 'goods',
                buy_type: this.query.type,
                goods_list,
                from: 'cart',
            })
            let that = this;
            that.$router.push({
                name: "Billing", query: {
                    data: encodeURIComponent(data)
                }
            });
            //localStorage.setItem('Billing',data);
            //that.$router.push("/Billing");

        },


    }
}
</script>
<style lang="less" scoped>
.top_nav {
    width: 100%;
    height: 150px;
    background: #f9f9f9;

    .logo {
        width: 170px;
        height: auto;
    }

    .pl60 {
        padding-left: 60px;
    }

    .top_title {
        padding-left: 60px;
        font-weight: 500;
        color: #040404;
        height: 100px;
        line-height: 100px;
        position: relative;

        &::before {
            content: '';
            width: 2px;
            height: 101px;
            background: rgba(98, 134, 171, 0.4);
            display: inline-block;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
        }
    }
}

.cart_tab {
    height: 48px;
    line-height: 46px;
    // margin-right: 40px;
    width: 176px;
    color: #040404;
    text-align: center;
    cursor: pointer;
    border: 1px solid #3D7EFE;
    background: #fff;
    border-radius: 23.5px;
    margin-right: 20px;

    &.ac {

        background: #3D7EFE;
        color: #fff;
    }
}

.col127 {
    color: #1275FF;
}

.cu {
    cursor: pointer;
}

.cart_tab_nav {

    height: 50px;
    background: #fafcff;
    padding-left: 45px;
}

.goods_item {
    padding-top: 15px;
    padding-bottom: 15px;
    background: #ffffff;
}

.choose_ico {
    width: 20px;
    height: auto;
}

.ml32 {
    margin-left: 32px;
}

.w144 {
    width: 60px;
}

.w318 {
    width: 22.7%;
    padding-left: 26px;
    padding-right: 34px;
}

.w50 {
    width: 120px;
}

.w68 {
    width: 152px;
}

.w160 {
    width: 160px;
}

.pr66 {
    padding-right: 66px;
}

.w166 {
    width: 166px;
}

.w152 {
    width: 152px;
}

.pl45 {
    padding-left: 45px;
}

.goods_cover {
    width: 60px;
    height: 60px;
    object-fit: cover;
}

.tips,
.lq_tips {
    width: 44px;
    text-align: center;
    color: #ffffff;
    font-size: 16px;
    font-weight: 400;
    padding-left: 5px;
    padding-right: 5px;
    height: 20px;
    border-radius: 4px;
    background: linear-gradient(153deg, #ff4d4d 0%, #ff652d 100%);
    margin-bottom: 6px;
}

.lq_tips {
    background: linear-gradient(117deg, #3D6CFE 0%, #4AC3FC 100%);
}

.arrow_down {
    width: 8px;
    height: auto;
}

.coleb {
    color: #EB3F25;
}

.del_item {
    width: 43px;
    height: auto;
}

.inp_nav {
    width: 67.3px;
    height: 40px;
    line-height: 36.8px;
    text-align: center;
    border: 1.6px solid #3d7efe;
    color: #272727;
    font-size: 16px;
    border-radius: 0;

    input {
        width: 100%;
        padding: 0;
        text-align: center;
    }
}

.pr45 {
    padding-right: 45px;
}

.cold8 {
    color: #D8D8D8;
}

.ico20 {
    width: 20px;
    height: auto;
}

.tips_no {
    color: #fff;
    font-size: 20px;
    font-weight: 400;
    width: 56px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    background: #D8D8D8;
    border-radius: 15px;
}

.pl35 {
    padding-left: 35px;
}

.h88 {
    height: 88px;
    background: #fff;
}

.btn_pay {
    width: 108px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    font-weight: 500;
    color: #FFFFFF;
    background: #1275FF;
    border-radius: 6px;
    margin-left: 25px;

    &.disabled {
        background: #BDD3FF;
    }
}

.mb90 {
    margin-bottom: 90px;
}

.recomd_box {

    min-height: 472px;
    background: #FFFFFF;
    margin-left: auto;
    margin-right: auto;
    border-top: 3px solid #3D7EFE;

    .recomd_tab {
        border-bottom: 1px solid rgba(98, 134, 171, 0.4);

        height: 68px;
        background: #FAFCFF;
    }

    .recomd_tab_item {
        width: 250px;
        line-height: 73px;
        text-align: center;
        font-weight: 400;
        font-size: 18px;
        color: #040404;
        cursor: pointer;
    }

    .recomd_tab_item+.recomd_tab_item {
        border-left: 1px solid rgba(98, 134, 171, 0.4);
    }

    .recomd_tab_item.ac {
        background: #FFFFFF;
        font-weight: bold;
        color: #1275FF;
        line-height: 69px;
        border-top: 3px solid #3D7EFE;
    }
}

.pr50 {
    padding-right: 50px;
}

.recomd_item {
    width: 252px;
    display: inline-block;
    vertical-align: top;
    margin-right: 100px;

    .cover {
        width: 252px;
        height: 252px;
        border-radius: 8px;
        margin-bottom: 25px;
        object-fit: cover;
    }
    &:nth-of-type(4n){margin-right: 0;}
}
@media screen and (max-width: 1440px) {
    .recomd_item {margin-right: 60px;}
}
.plr45 {
    padding-left: 45px;
    padding-right: 45px;
}

.ico56 {
    width: 56px;
    height: auto;
}


.select_box {
    width: 139px;
    height: 40px;
    border-radius: 8px;
    border: 1px solid rgba(98, 134, 171, 0.4);
    padding-left: 18px;
    padding-right: 18px;
    display: flex;
    align-items: center;
    position: relative;
    font-size: 16px;
    color: #3D7EFE;
    cursor: pointer;

    &>div {
        color: #3D7EFE;
    }

    &.disabled {
        border: 1px solid #D8D8D8;
        color: #D8D8D8;
    }

    &.disabled>div {
        color: #D8D8D8;
    }

    .arrow {
        width: 12px;
        height: auto;
    }
}

.pr {
    position: relative;
}

.select_link {
    width: 139px;
    top: 40px;
    left: 0;
    position: absolute;
    background: #FFFFFF;
    box-shadow: 0px 4px 8px 0px rgba(98, 134, 171, 0.2);
    border-radius: 0px 0px 10px 10px;
    cursor: pointer;

    &_item {
        height: 48px;
        line-height: 48px;
        width: 100%;
        padding: 0 8px;
        font-size: 16px;
        color: #040404;
    }
}

.tdl {
    text-decoration: underline;
}

.nothing_box {
    width: 100%;
    height: 548px;
    background: #FFFFFF;

    .null {
        width: 331px;
        height: auto;
        display: block;
    }

    .return {
        width: 145px;
        height: auto;
        display: block;
        margin-top: 15px;
    }
}
</style>
